/* global Config */

import {mapValues} from 'lodash';

const configBase = {
    baseUrl: Config.base.baseUrl,
    contentType: 'application/json',
    crossDomain: false,
    method: 'GET',
    responseType: 'json',
    timeout: 120000,
};

const servicesFormConfig = {
    addShelf: {
        baseUrl: Config.base.catalogUrl,
        dependentServicesDataKey: 'loadParentShelfDetail',
        method: 'PUT',
        path: 'shelf',
        updateServicesDataKeys: ['loadParentShelfDetail'],
    },
    changePassword: {
        method: 'PUT',
        path: 'users/updatePassword',
    },
    createUser: {
        method: 'POST',
        path: 'users',
    },
    editShelf: {
        dependentServicesDataKey: 'loadShelfDetail',
        method: 'POST',
        path: 'shelves/edit-shelf',
        updateServicesDataKeys: ['loadShelfDetail'],
    },
    editUser: {
        dependentServicesDataKey: 'userDetail',
        method: 'PUT',
        path: 'users',
        updateServicesDataKeys: ['users', 'userDetail'],
    },
};

export default mapValues(servicesFormConfig, config => ({...configBase, ...config}));
